import { Trash2 } from 'lucide-react';
import React from 'react';
import { BaseActionButton, BaseActionButtonProps } from './BaseActionButton';

export interface DeleteDeviceButtonProps
  extends Omit<BaseActionButtonProps, 'action'> {
  deviceId?: string;
  deviceName?: string;
  onDelete: (deviceId: string) => Promise<void>;
}

export const DeleteDeviceButton: React.FC<DeleteDeviceButtonProps> = ({
  deviceId,
  deviceName,
  onDelete,
  onSuccess,
  onError,
  confirmBeforeAction = true,
  confirmMessage,
  confirmTitle = 'Conferma Invalidazione',
  children,
  ...buttonProps
}) => {
  const handleDelete = async () => {
    if (!deviceId) {
      throw new Error('Device ID is required for deletion');
    }
    await onDelete(deviceId);
  };

  const defaultConfirmMessage =
    `⚠️ ATTENZIONE: Invalidazione Permanente\n\n` +
    `Il dispositivo "${deviceName || 'Device'}" verrà ELIMINATO PERMANENTEMENTE dal sistema.\n\n` +
    `Questa azione:\n` +
    `• Elimina completamente il dispositivo\n` +
    `• Rimuove tutti i dati associati al dispositivo\n` +
    `• È IRREVERSIBILE\n\n` +
    `Sei sicuro di voler procedere?`;

  return (
    <BaseActionButton
      action={handleDelete}
      tooltip='Elimina permanentemente il dispositivo'
      confirmBeforeAction={confirmBeforeAction}
      confirmMessage={confirmMessage || defaultConfirmMessage}
      confirmTitle={confirmTitle}
      onSuccess={onSuccess}
      onError={onError}
      showNotification={false} // DeleteDeviceButton has its own modal, no need for notifications
      leftSection={<Trash2 size={16} />}
      color='red'
      variant='light'
      size='xs'
      {...buttonProps}
    >
      {children || 'Elimina'}
    </BaseActionButton>
  );
};
